import config from 'config'

const customerApi = `${config.apiHost}`

export default {
    getWarningList: {
        url: `${customerApi}/oem-customer/api/customer_early_warning`,
        type: 'GET',
    },
}
